import { api } from "@api/api";
import { SyncReceivedBooksFormValues } from "@modules/syncReceivedBooks/validations";
import { TriggerSyncResponse } from "./types";

export async function triggerSyncService(
  data: SyncReceivedBooksFormValues
): Promise<TriggerSyncResponse> {
  const cpfs = data.cpfs
    ? data.cpfs.split(",").map((cpf) => cpf.trim()).filter(Boolean)
    : undefined;

  const payload = {
    agreement_ids: data.agreement_id,
    months: data.months,
    years: data.years,
    ...(data.product_id ? { product_id: data.product_id } : {}),
    ...(cpfs?.length ? { cpfs } : {}),
  };

  const { data: result } = await api.post<TriggerSyncResponse>(
    "v2/bookstore/sync_received_books_custom_filters/",
    payload
  );

  return result;
}
